import { apiRequest } from "../../services/apiService";
import { ADD_SURVEY_URL_FAIL, ADD_SURVEY_URL_REQUEST, ADD_SURVEY_URL_SUCCESS, DELETE_SURVEY_URL_FAIL, DELETE_SURVEY_URL_REQUEST, DELETE_SURVEY_URL_SUCCESS, GET_CUSTOM_VARIABLE_REQUEST, GET_SURVEY_URL_FAIL, GET_SURVEY_URL_REQUEST, GET_SURVEY_URL_SUCCESS, UPDATE_SURVEY_URL_FAIL, UPDATE_SURVEY_URL_REQUEST, UPDATE_SURVEY_URL_STATUS_FAIL, UPDATE_SURVEY_URL_STATUS_REQUEST, UPDATE_SURVEY_URL_STATUS_SUCCESS, UPDATE_SURVEY_URL_SUCCESS } from "../constant";


//URL(Link) - works for both survey and group
export const getSurveyUrl = (survey_id = null, group_id = null) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_URL_REQUEST });
        
        // Build query parameters based on context
        let queryParams = '';
        if (group_id) {
            queryParams = `group_id=${group_id}`;
        } else if (survey_id) {
            queryParams = `survey_id=${survey_id}`;
        }
        
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getSurveyLink?${queryParams}`,
            showErrorToast: false,
        })
        if (response) {
            dispatch({ type: GET_SURVEY_URL_SUCCESS, payload: response.data?.data });
        }
        else if (error) {
            dispatch({ type: GET_SURVEY_URL_FAIL });
        }
    }
}

export const addSurveyUrl = (data, successCallback, failCallback) => {
    return async (dispatch) => {
        // For surveys, get survey_id from localStorage if not provided
        // For groups, data should already contain su_group_id and link_scope
        const survey_id = data.link_scope === 'group' ? null : (data.survey_id || localStorage.getItem('survey_id'));

        dispatch({ type: ADD_SURVEY_URL_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/crtSurveyLink`,
            data: data.link_scope === 'group' ? data : { ...data, survey_id }
        })
        if (response) {
            dispatch({ type: ADD_SURVEY_URL_SUCCESS });
            successCallback()
        }
        else if (error) {
            console.log('error', error.response?.data?.data)
            const err = error.response?.data?.data
            if (!err.isUnique) {
                failCallback({ name: 'Link with this name already exist' })
            }
            dispatch({ type: ADD_SURVEY_URL_FAIL });
        }
    }
}

export const updateSurveyUrl = (data, successCallback) => {
    return async (dispatch) => {

        dispatch({ type: UPDATE_SURVEY_URL_REQUEST });
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updSurveyLink`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_SURVEY_URL_SUCCESS });
            successCallback()
        }
        else if (error) {
            dispatch({ type: UPDATE_SURVEY_URL_FAIL });
        }
    }
}

export const deleteSurveyUrl = (id) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_SURVEY_URL_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delSurveyLink?survey_link_id=${id}`
        })
        if (response) {
            dispatch({ type: DELETE_SURVEY_URL_SUCCESS, payload: id });
        }
        else if (error) {
            dispatch({ type: DELETE_SURVEY_URL_FAIL });
        }
    }
}

export const updateLinkStatus = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_SURVEY_URL_STATUS_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/updSurveyLinkStatus`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_SURVEY_URL_STATUS_SUCCESS, payload: data });
        }
        if (error) {
            dispatch({ type: UPDATE_SURVEY_URL_STATUS_FAIL });
        }
    }
}
